<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex  justify-content-between">
        <back-arrow
          class="truncate"
          routeBack="StructureIndex"
          :title="$t('Structure') + ' - ' + getValue('structureName')"/>
        <show-actions
          :deleteItem=allowDelete
          :editItem=allowEdit
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.name') }}</div>
                  <div> {{ getValue('structureName') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.address') }}</div>
                  <div> {{ getValue('address') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.address.details') }}</div>
                  <div> {{ getValue('addressDetails') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.postalCode') }}</div>
                  <div> {{ getValue('postalCode') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.City') }}</div>
                  <div> {{ getValue('city') }}</div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.lastName') }}</div>
                  <div> {{ getValue('contactLastname') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.firstName') }}</div>
                  <div> {{ getValue('contactFirstname') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Username') }}</div>
                  <div> {{ getValue('contactUsername') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('structure.phoneNumber') }}</div>
                  <div> {{ getValue('contactPhoneNumber') }}</div>
                </div>
              </div>
            </div>

            <div class="row" v-if="this.technicians.length>0">
              <div class="col-md-12">
                <div class="d-flex flex-column mb-4 custom-border">
                </div>
              </div>
              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Technicians') }}</div>
                  <div class="d-flex">
                    <div v-for="technician in this.technicians" class="mr-4 textual-link">
                      <a @click="goToTechnician(technician.id)">{{technician.tostring }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="structure"
      controllerName="structure"
      itemSingularName="structure"
      itemSingularNameUpp="Structure"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'StructureShow',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    ItemDeleteModal,
    ShowActions
  },

  data () {
    return {
      structureId: this.$route.params.structureId,
      structure: {},
      allowDelete: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin,
      allowEdit: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin,
      technicians: []
    }
  },

  mounted () {
    this.fetchData()
  },

  watch: {
    'structure': async function () {
      if (this.structure && this.structure.nbTechnicians > 0) {
        await this.fetchTechnicianForStructure()
      }
    }
  },

  computed: {
    getValue() {
      return (path) => {
        const properties = path.split('.');
        let value = properties.reduce((prev, curr) => {
          return prev && prev[curr] ? prev[curr] : null;
        }, this.structure);
        return value !== null ? value : 'N/A';
      };
    },
  },

  methods: {

    async fetchData () {
      if (this.structureId) {
        await this.fetchStructure()
      }
    },

    async fetchStructure () {
      api
        .get('/structure/' + this.structureId)
        .then(response => {
          this.structure = response.data
          if (this.structure.isDefaultStructure) {
            this.$router.push({
                name: 'StructureIndex'
              },
              () => {
                this.$nextTick(() => {
                  this.$bvToast.toast(this.$i18n.t('unauthorized.error'), {
                    title: this.$i18n.t('Error.title'),
                    autoHideDelay: 4000,
                    toaster: 'b-toaster-bottom-right',
                    solid: true
                  })
                })
              })
          }
        })
    },

    async fetchTechnicianForStructure () {
      api
        .get('/structure/getAllTechniciansForStructure/' + this.structureId)
        .then(response => {
          this.technicians = response.data
        })
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'StructureEdit',
        params: {
          structureId: this.structure.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.$router.push({
        name: 'StructureIndex'
      })
    },

    goToTechnician (id) {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          techId: id
        }
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/structure/StructureShow.vue